import { Departments } from '@/types';

export namespace botTypes {
  export type AllowedUser = {
    _id: string;
    name: string;
  };

  export type Page = {
    _id: string;
    externalId: string;
    name: string;
    department: Departments;
    subDepartment: botTypes.SubDepartments;
    appPages?: string[];
    isExpert?: boolean;
    isMandatoryManagerSelect?: boolean;
    deletedAt?: number;
  };

  export enum SubDepartments {
    test = 'test',
    tr_1 = 'tr_1',
    tr_2 = 'tr_2',
    tr_3 = 'tr_3',
    tr_4 = 'tr_4',
    tr_call = 'tr_call',
    en_1 = 'en_1',
    la_1 = 'la_1',
    la_2 = 'la_2',
    la_3 = 'la_3',
    br_1 = 'br_1',
    ru_1 = 'ru_1',
    ru_2 = 'ru_2',
    ru_3 = 'ru_3',
    ru_4 = 'ru_4',
    ru_opk_1 = 'ru_opk_1',
    ru_opk_2 = 'ru_opk_2',
    ru_opk_3 = 'ru_opk_3',
  }

  export type AddAllowedUser = (data: Omit<AllowedUser, '_id'>) => Promise<void>;
  export type EditAllowedUser = (data: {
    _id: string;
    name: string;
  }) => Promise<{ user: AllowedUser }>;
  export type GetAllowedUsers = () => Promise<{ users: AllowedUser[] }>;
  export type RemoveAllowedUserData = {
    _id: string;
  };

  export type AddPage = (data: Omit<Page, '_id'>) => Promise<void>;
  export type EditPage = (data: Page) => Promise<{ page: Page }>;
  export type GetPages = (params: { department: Departments }) => Promise<{ pages: Page[] }>;
  export type RemovePageData = {
    _id: string;
  };

  export type PageFormValues = Omit<Page, '_id' | 'subDepartment'> & {
    subDepartment?: SubDepartments;
  };
}
